import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export const useDescriptionContent = () => {
  const { t } = useTranslations(translations);

  return t('homepage');
};
